// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import translate from "@insite/client-framework/Translate";
import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import { css } from "styled-components";

searchBoxStyles.search = {
    cssOverrides: {
        formField: css`
            flex-direction: row;
            align-items: center;
            label {
                width: auto;
                font-weight: ${fontConfig.weight.bold};
                font-size: ${fontConfig.fontSize.small}px;
                margin-right: 8px;
                white-space: nowrap;
            }
            @media (max-width: 650px) {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
        inputSelect: css`
            padding-left: 32px !important;
            font-size: ${fontConfig.fontSize.small}px;
            height: 32px;
        `,
    },
    iconProps: {
        src: "Search",
        size: 14,
        color: "common.ui1",
        css: css`
            &&&&&& {
                padding: 0;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                svg {
                    opacity: 0.8;
                    max-height: 14px;
                    max-width: 14px;
                }
            }
        `,
    },
    label: translate("Search"),
};
